export default __webpack_public_path__ + "static/media/theme.cde3e683.svg";